"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fillRule: "evenodd",
  d: "M6.4 4A2.4 2.4 0 0 0 4 6.4v11.2A2.4 2.4 0 0 0 6.4 20h11.2a2.4 2.4 0 0 0 2.4-2.4V6.4A2.4 2.4 0 0 0 17.6 4zm11.01 4.195a.68.68 0 0 1 0 .943l-6.5 6.667a.64.64 0 0 1-.92 0l-2.6-2.667a.68.68 0 0 1 0-.943.64.64 0 0 1 .92 0l2.14 2.195 6.04-6.195a.64.64 0 0 1 .92 0",
  clipRule: "evenodd"
}), 'CheckboxChecked');
